// extracted by mini-css-extract-plugin
module.exports = {"form":"SocialButton_form__KeoEl","socialButton":"SocialButton_socialButton__m4uzR"};